
export default function Logo(props){

    const src = props.src ? (props.src.includes('?') ? `${props.src}&t=${props.timestamp || ''}` : `${props.src}?t=${props.timestamp || ''}`) : props.src;

    return(
        <img src={src} alt={props.alt?props.alt:""}  width={props.width?props.width:"auto"} height={props.height?props.height:"auto"}/>
    )
}
